// JSX Structure Syntactic Sugar. Never reach the render code.
/* istanbul ignore next */
const DescriptionsItem = (props) => {
    return props.children;
};
export default DescriptionsItem;
